<script setup>
import { computed, onMounted, watch } from "vue";
import DxButton from "devextreme-vue/button";
import { useRoute, useRouter } from "vue-router";
import state from "./routerModalState";

const props = defineProps({
  theme: {
    type: String,
    default: "patient",
  },
});

const router = useRouter();
const route = useRoute();

const getRouteClasses = computed(() => {
  const routeClass = route?.path?.replace(/\//g, "-");
  return `${props.theme} ${
    route.name ? "route-name-" + route.name : ""
  } route-path${routeClass}`;
});

const closeModal = () => {
  // In case the link is copied and directly opened in a browser tab replace with parent path, else just trigger browser back
  if (!window.history.state.back) {
    const parentPath = route?.meta?.parentPath;
    router.replace(parentPath ?? "/");
  } else {
    router.back();
  }
};

watch(route, (newVal) => {
  state.showModal = newVal?.meta?.showModal;
});

onMounted(() => {
  state.showModal = route.meta.showModal;
});
</script>

<template>
  <div
    v-if="state.showModal"
    :class="[getRouteClasses, 'modal-parent modal-fixed']"
  >
    <div class="modal route-modal modal-fixed">
      <DxButton class="btn-close" icon="close" @click="closeModal()" />
      <router-view />
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-fixed {
  position: fixed;
  z-index: 1;
}
.modal-parent {
  background-color: rgba(31, 153, 214, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.modal {
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background-color: white;
}
.btn-close {
  position: absolute;
  border: none;
  padding: 0;
  top: 0em;
  right: 0em;
  background-color: #1f3462;
  :deep(.dx-icon) {
    position: relative;
    color: #fff;
  }
}
.symptoms {
  .modal {
    display: flex;
  }
}
.patient,
.symptoms {
  .modal {
    background-image: url("../../assets/patient-modal-background.png");
    background-size: cover;
  }
}
// .symptoms {
//   .modal {
//     background-image: url("../../assets/mask_group.png");
//     background-position: -50px -50px;
//   }
// }
</style>
